import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AWARD_CODES } from "../../common/enums/award-codes";
import { useAppDispatch, useAppSelector } from "../../store";
import { storedLocale } from "../Authentication/util";
import defaultContent from "../../content/faa";
import { RegulationInfoBanner } from "../../components/RegulationInfoBanner/RegulationInfoBanner";
import { PageTitleSection } from "../../common/components/PageTitleSection/PageTitleSection";
import { BonusInfoFooter } from "../../common/components/BonusInfoFooter/BonusInfoFooter";
import { KpiInfoModal } from "../../common/components/KpiSelector/KpiInfoModal/KpiInfoModal";
import { TermsAndConditions } from "../../common/components/TermsAndConditions/TermsAndConditions";
import "./FAA.scss";
import { FullPageComponentLoader } from "../../common/components/FullPageComponentLoader/FullPageComponentLoader";
import { useImportLitComponent, LitComponent } from "../../common/hooks/useImportLitComponent";

export default function FAA() {
  const { selectedPeriod } = useAppSelector((state) => state.period);
  const { eligibleIncentives } = useAppSelector((state) => state.boot.shellConfig);
  const { t } = useTranslation(["faa"]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isImported } = useImportLitComponent({ component: LitComponent.FAA });
  const [showSuperLegsInfoModal, setShowSuperLegsInfoModal] = useState(false);
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);

  useEffect(() => {
    if (eligibleIncentives !== undefined) {
      const faaAccess = eligibleIncentives.some(
        (incentive: { awardNumber: any }) => incentive.awardNumber === AWARD_CODES.FAA,
      );
      if (faaAccess === false) {
        navigate("/404");
      }
    }
  }, [dispatch, eligibleIncentives, navigate]);

  useEffect(() => {
    const handleSuperLegInfoModal = () => setShowSuperLegsInfoModal(true);
    window.addEventListener("acc-faa-super-leg-info-modal", handleSuperLegInfoModal);
    return () => window.removeEventListener("acc-faa-super-leg-info-modal", handleSuperLegInfoModal);
  }, []);

  useEffect(() => {
    const handleTermsModalOpen = () => setShowTermsAndConditions(true);
    document.addEventListener("faa-terms-modal-open", handleTermsModalOpen);
    return () => document.removeEventListener("faa-terms-modal-open", handleTermsModalOpen);
  }, []);

  const handleDismissTerms = () => {
    setShowTermsAndConditions(false);
  };

  const handleAgreeTerms = () => {
    sessionStorage.setItem("terms_and_conditions_accepted", "true");
    setShowTermsAndConditions(false);
    document.dispatchEvent(
      new CustomEvent("faa-terms-modal-accepted", {
        bubbles: true,
        composed: true,
      }),
    );
  };

  if (!isImported) {
    return <FullPageComponentLoader />;
  }
  return (
    <main>
      <RegulationInfoBanner id="regulationInfoBanner-faa" />
      <PageTitleSection title={`${t("pageTitle", defaultContent["pageTitle"])}`} hideTimeStamp />
      <div className="FAA__wrapper">
        <acc-faa-summary
          id="acc_faa_summary"
          mode="standalone"
          period={selectedPeriod}
          locale={storedLocale()}
          moduleId={"CPP"}
        ></acc-faa-summary>
      </div>
      <BonusInfoFooter />
      <KpiInfoModal open={showSuperLegsInfoModal} onClose={() => setShowSuperLegsInfoModal(false)} kpi="superLegs" />
      <TermsAndConditions
        open={showTermsAndConditions}
        dismissCallbackFn={handleDismissTerms}
        agreeCallbackFn={handleAgreeTerms}
      />
    </main>
  );
}
